import Layout from '@/views/configuration/Layout.vue';

export default {
    path: '/configuration',
    component: Layout,
    children: [
        { path: 'summary', component: () => import('@/views/configuration/Summary.vue') },
    ]
};
